"use strict";

var readUrlParam = function readUrlParam(name) {
  var url = new URL(window.location.href);
  return url.searchParams.get(name);
};
var getQueryParamsAsObject = function getQueryParamsAsObject(queryString) {
  var query = queryString.replace('?', '');
  var params = {};
  if (query) {
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      var varName = pair[0];
      var varValue = pair[1];
      var alreadyVisitedVar = params[varName] != null;
      if (alreadyVisitedVar) {
        if (Array.isArray(params[varName])) {
          params[varName].push(decodeURIComponent(varValue));
        } else {
          params[varName] = [params[varName], decodeURIComponent(varValue)];
        }
      } else {
        params[varName] = decodeURIComponent(varValue);
      }
    }
  }
  return params;
};
var removeParamsFromUrl = function removeParamsFromUrl(url, paramsToRemove, removeHash) {
  if (!paramsToRemove || paramsToRemove.length === 0) return url;
  var urlObj = new URL(url);
  if (removeHash) {
    urlObj.hash = '';
  }
  paramsToRemove.forEach(function (param) {
    urlObj.searchParams["delete"](param);
  });
  return "".concat(urlObj.toString());
};
var addParamsToUrl = function addParamsToUrl(url, keyValueObjects) {
  url = removeTrailingSlash(url);
  if (!keyValueObjects || keyValueObjects.length === 0) return url;
  var urlObj = new URL(url);
  keyValueObjects.forEach(function (entry) {
    urlObj.searchParams.set(entry.key, entry.value);
  });
  return "".concat(urlObj.toString());
};
var addParamToUrl = function addParamToUrl(url, paramName, paramValue) {
  return addParamsToUrl(url, [{
    key: paramName,
    value: paramValue
  }]);
};
var removeTrailingSlash = function removeTrailingSlash(url) {
  return url.replace(/\/$/, '');
};
module.exports = {
  readUrlParam: readUrlParam,
  getQueryParamsAsObject: getQueryParamsAsObject,
  removeParamsFromUrl: removeParamsFromUrl,
  addParamToUrl: addParamToUrl,
  addParamsToUrl: addParamsToUrl,
  removeTrailingSlash: removeTrailingSlash
};